import { Reducer, Action } from "redux";
import { IDownloadAppState, KnownAction, GET_MOBILE_DEVICE_COUNT, GET_AUTHENTICATED_DEVICES, GET_MOBILE_DEVICE_COUNT_LOADER, GET_DEVICES_LOADER } from "./types";

export const reducer: Reducer<IDownloadAppState> = (state: IDownloadAppState | undefined, incomingAction: Action): IDownloadAppState => {
    if (state === undefined) {
        return { numberOfAuthenticatedDevices: 0, isLoading: false, isLoadingDevices: false };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case GET_MOBILE_DEVICE_COUNT:
            return {
                ...state,
                numberOfAuthenticatedDevices: action.numberOfAuthenticatedDevices,
            };
        case GET_AUTHENTICATED_DEVICES:
            return {
                ...state,
                authenticatedDevices: action.authenticatedDevices,
            };
        case GET_MOBILE_DEVICE_COUNT_LOADER:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        case GET_DEVICES_LOADER:
            return {
                ...state,
                isLoadingDevices: action.isLoadingDevices,
            };
        default:
            return state;
    }
};
